import React, { useEffect ,useState} from 'react';
import { BrowserRouter as Router, Routes, Route, RouterProvider } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Attorneys } from './components/Attorneys';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Blogs } from './components/Blogs';
import { BlogDetail } from './components/BlogDetail';
import { LanguageProvider } from './context/LanguageContext';
import Register from './components/Register';
import Login from './components/Login';
import UserProfile from './components/UserProfile';
import AdminRoute from './components/AdminRoute'
import AdminDashboard from './components/AdminDashboard'
import { AuthContextProvider } from './components/AuthContext';
import { PostBlog } from './components/PostBlog';
// import { BlosRoute } from '/components/BlosRoute';
import EditPost from './components/EditPost';
import NotFoundPage from './components/NotFoundPage';
import Emails from './components/Emails';
import CreatePostButton from './components/CreatePostButton';
import { FaWhatsapp } from "react-icons/fa";
import { HeaderPost } from './components/HeaderPost';
import { TopBar } from './components/TopBar';
import LegalConsultations from './components/parts/LegalConsultations';
import ContractServices from './components/parts/ContractServices';
import LitigationServices from './components/parts/LitigationServices';
import ArbitrationServices from './components/parts/ArbitrationServices';
import EstateLiquidationServices from './components/parts/EstateLiquidationServices';
import WaqfAndWillServices from './components/parts/WaqfAndWillServices';
import ExecutionServices from './components/parts/ExecutionServices';
import DocumentationServices from './components/parts/DocumentationServices';
import RealEstateRegistration from './components/parts/RealEstateRegistration';
import DebtCollection from './components/parts/DebtCollection';
import StartupsLegalServices from './components/parts2/StartupsLegalServices';
import WorkRegulationsServices from './components/parts2/WorkRegulationsServices';
import JudicialCustodyServices from './components/parts2/JudicialCustodyServices';
import ComplianceAndGovernance from './components/parts2/ComplianceAndGovernance';
import IntellectualPropertyServices from './components/parts2/IntellectualPropertyServices';
import FranchiseServices from './components/parts2/FranchiseServices';
import ForeignInvestmentServices from './components/parts2/ForeignInvestmentServices';
import BankruptcyProceedings from './components/parts2/BankruptcyProceedings';
import CyberAndECommerceServices from './components/parts2/CyberAndECommerceServices';
import PriceListAndFees from './components/pays/PriceListAndFees';
import LegalResearchAndRegulations from './components/parts2/LegalResearchAndRegulations';
import CostEstimation from './components/pays/CostEstimation';
import { Partners } from './components/Partners';
import { HelmetProvider } from 'react-helmet-async';
import { useSEO } from './components/assets/hooks/useSeo';
  // const [loggedIn, setLoggedIn] = useState(false);


  //  <div>
  //     {loggedIn ? (
  //       <>
  //         <Protected />
  //         <Logout onLogout={() => setLoggedIn(false)} />
  //       </>
  //     ) : (
  //       <Login onLogin={() => setLoggedIn(true)} />
  //     )}
  //   </div>
  
  function App() {
    useEffect(() => {
    // التحقق مما إذا كان الرابط يحتوي على هاش عند تحميل الصفحة الرئيسية
    if (window.location.hash) {
      const targetElement = document.querySelector(window.location.hash);
      if (targetElement) {
        // تأخير بسيط بمقدار 150 ملي ثانية لضمان رندر العناصر بالكامل على الشاشة
        setTimeout(() => {
          const offset = document.querySelector('header')?.offsetHeight || 0;
          window.scrollTo({
            top: targetElement.offsetTop - offset,
            behavior: 'smooth'
          });
        }, 150);
      }
    }
  }, []);

//   function AppContent() {
//   // الآن استدعاء الـ Hook هنا آمن تماماً لأن هذا المكون يقع داخل الـ <Router> في الأسفل
//   useSEO(); 

//   return (
//    <Routes>
//       {/* الجزء الأول */}
//       <Route path="/legal" element={<LegalConsultations/>} />
//       <Route path="/contract" element={<ContractServices/>} />
//       <Route path="/litigation" element={<LitigationServices/>} />
//       <Route path="/arbitration" element={<ArbitrationServices/>} />
//       <Route path="/estate-liquidation" element={<EstateLiquidationServices/>} />
//       <Route path="/waqf-will" element={<WaqfAndWillServices/>} />
//       <Route path="/execution" element={<ExecutionServices/>} />
//       <Route path="/documentation" element={<DocumentationServices/>} />
//       <Route path="/real-estate-registration" element={<RealEstateRegistration/>} />
//       <Route path="/debt-collection" element={<DebtCollection/>} />

//       {/* الجزء الثاني */}
//       <Route path="/startups" element={<StartupsLegalServices/>} />
//       <Route path="/work-regulations" element={<WorkRegulationsServices/>} />
//       <Route path="/judicial-custody" element={<JudicialCustodyServices/>} />
//       <Route path="/compliance-governance" element={<ComplianceAndGovernance/>} />
//       <Route path="/intellectual-property" element={<IntellectualPropertyServices/>} />
//       <Route path="/franchise" element={<FranchiseServices/>} />
//       <Route path="/foreign-investment" element={<ForeignInvestmentServices/>} />
//       <Route path="/bankruptcy-proceedings" element={<BankruptcyProceedings/>} />
//       <Route path="/cyber-e-commerce" element={<CyberAndECommerceServices/>} />
//       <Route path="/legal-research-regulations" element={<LegalResearchAndRegulations/>} />
//     </Routes>
   
//   );
// }

  return (
    <HelmetProvider>

    <AuthContextProvider>
    <Router>

      <LanguageProvider>
        <div dir="rtl" className="font-sans min-h-screen bg-gray-50 overflow-x-hidden">
          <Routes>

            <Route path="/" element={
              <main>
                {/* <TopBar/> */}
                <Header />
                <Hero />
                <Services />
                <About />
                <Attorneys />
                {/* <Testimonials /> */}

                <Contact />
                <Partners />
                <Blogs />
                    <CreatePostButton/>

              </main>
            } />



    (
        <>
{/* parts 1 */}

           <Route path="/legal" element={<LegalConsultations/>} />
                      <Route path="/contract" element={<ContractServices/>} />
                      <Route path="/litigation" element={<LitigationServices/>} />
                      <Route path="/arbitration" element={<ArbitrationServices/>} />
                      <Route path="/estate-liquidation" element={<EstateLiquidationServices/>} />
                      <Route path="/waqf-will" element={<WaqfAndWillServices/>} />
                      <Route path="/execution" element={<ExecutionServices/>} />
                      <Route path="/documentation" element={<DocumentationServices/>} />
                      <Route path="/real-estate-registration" element={<RealEstateRegistration/>} />
                      <Route path="/debt-collection" element={<DebtCollection/>} />

                      {/* parts 1 */}
                      {/* parts 2  */}
                       <Route path="/startups" element={<StartupsLegalServices/>} />
                      <Route path="/work-regulations" element={<WorkRegulationsServices/>} />
                      <Route path="/judicial-custody" element={<JudicialCustodyServices/>} />
                      <Route path="/compliance-governance" element={<ComplianceAndGovernance/>} />
                      <Route path="/intellectual-property" element={<IntellectualPropertyServices/>} />
                      <Route path="/franchise" element={<FranchiseServices/>} />
                      <Route path="/foreign-investment" element={<ForeignInvestmentServices/>} />
                      <Route path="/bankruptcy-proceedings" element={<BankruptcyProceedings/>} />
                      <Route path="/cyber-e-commerce" element={<CyberAndECommerceServices/>} />
                      <Route path="/legal-research-regulations" element={<LegalResearchAndRegulations/>} /> 


{/* parts2  */}
{/* FEES  */}
                      <Route path="/price-list-fees" element={<PriceListAndFees/>} />
                      <Route path="/cost-estimation" element={<CostEstimation/>} />
                      {/* FEES */}

          {/* <Route path="/blogs" element={<BlosRoute />} /> */}
          {/* <Route path="/blogs/:id" element={
            <div>

            <HeaderPost/>
            <BlogDetail />
          
          </div>
          } 
            
            /> */}
          {/* <Route path="/register" element={<Register />} /> */}
          {/* <Route path="/users" element={<UserProfile />} /> */}
          <Route path="post" element={
                <div>
            <HeaderPost/>
            <PostBlog />
            </div>
            } />
          <Route path="/posts/edit/:id" element={
                <div>
            <HeaderPost/>
            <EditPost />
            </div>
            } />

                    <Route path="/emails" element={
                      <div>
            <HeaderPost/>

                      <Emails />
                      </div>
                      
                      } />

          <Route path="*" element={<NotFoundPage />} />


          {/* <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          /> */}
        </>
      )  (



        <Route path="/login" element={<Login />} />

          </Routes>

          <Footer />
        </div>
      </LanguageProvider>
    </Router>
  </AuthContextProvider>
    </HelmetProvider>

  );
}

export default App;